"use client";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import type { IPageEditorial } from "@contentful-api/types/contentful";
import { ModulesRenderer } from "@lib/contentful/modules-renderer/ModulesRenderer";
import dynamic from "next/dynamic";
import { EccoClubCTAs } from "./EccoClubCTAs";

const Headline = dynamic(() =>
    import("@components/cms/headline/Headline").then((mod) => mod.Headline)
);

interface EccoClubCampaignLayoutProps {
    page: IPageEditorial;
}

export const EccoClubCampaignLayout = ({ page }: EccoClubCampaignLayoutProps) => {
    const { siteSettings } = useGlobalContent();
    const { fields: { modules, title, titleSize, desc, descriptionSize } = {} } = page;
    const authorizationInvitation = siteSettings.auth.authorizationInvitation;

    return (
        <>
            {(title || desc) && (
                <Headline
                    title={title}
                    titleSize={titleSize}
                    description={desc}
                    descriptionSize={descriptionSize}
                    isModule={false}
                />
            )}
            <EccoClubCTAs />
            <ModulesRenderer modules={modules} authorizationInvitation={authorizationInvitation} />
        </>
    );
};
